module.exports = __webpack_public_path__ + "img/apple.f48d1c6f.png";